import { Directive, HostListener } from '@angular/core';
import { debounce } from '../core/decorators/debounce';
import { formatDate } from '../core/utils/date-fns-utils';

/**
 * Prepend today's date (yyyy-MM-dd) onto the textarea value if its content
 * doesn't begin with it already. Also adds a new line right after this date.
 * Mostly used when editing the `comment` LSC fields.
 */
@Directive({
    selector: '[appDblClickPrependToday]',
    standalone: true,
})
export class DblclickPrependTodayDirective {

  @HostListener('dblclick', ['$event'])  // listen to double clicks
  @debounce(250)                   // prevent quick successive dbl-clicks
  onDoubleClick(event: KeyboardEvent) {
    this.handleContentModification(event?.target as HTMLTextAreaElement);
  }

  constructor() {
  }

  /**
   * Handle content modification based on the present of today's date stamp.
   * @param textarea
   * @private
   */
  private handleContentModification(textarea: HTMLTextAreaElement) {
    if (!textarea) {
      return;
    }

    const today = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const todayLine = today + ':\n';

    let currentContent = textarea.value;

    if (!currentContent?.startsWith(todayLine)) {
      if (currentContent) {
        currentContent = '\n\n' + currentContent;
      }

      textarea.value = todayLine + currentContent;
      // manually dispatch an input event to which event listeners are bound
      // so that the prepended date is saved on the BE
      textarea.dispatchEvent(new Event('input'));
    }
  }
}
